import { Container, Sprite, type Texture } from 'pixi.js';
import type { Chest } from '@/dungeon/chests';
import { TILE_SIZE } from '@/sprites/tiles';
import type { ChestSpriteKey } from '@/sprites/chest';

/**
 * Chests on the floor.
 *
 * Pooled and culled to the view, like every other renderer here. There are a
 * handful per floor, so this is cheap by construction rather than by effort.
 */
export class ChestRenderer {
  readonly container = new Container();
  private readonly pool: Sprite[] = [];

  constructor(private readonly textures: Readonly<Record<ChestSpriteKey, Texture>>) {}

  render(chests: readonly Chest[]): void {
    let used = 0;

    for (const chest of chests) {
      const sprite = this.spriteAt(used++);
      sprite.texture = this.textures[chest.opened ? 'chestOpen' : 'chestClosed'];
      sprite.position.set(chest.x * TILE_SIZE, chest.y * TILE_SIZE);
      sprite.visible = true;
    }

    for (let i = used; i < this.pool.length; i++) this.pool[i]!.visible = false;
  }

  private spriteAt(index: number): Sprite {
    let sprite = this.pool[index];
    if (!sprite) {
      sprite = new Sprite();
      this.pool.push(sprite);
      this.container.addChild(sprite);
    }
    return sprite;
  }

  destroy(): void {
    this.container.destroy({ children: true });
  }
}
